import { Form } from 'formik';

import styled from 'styled-components';

export const EmergencyHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const MainTitle = styled.div`
  font: normal normal 600 22px / 26px Biotif;
  margin: 17px;
  padding-top: 15px;
  padding-left: 10px;
  display: flex;
}
`;

export const BelowTitle = styled.div`
  font-size: 24px;
  font-weight: bold;
  margin: 17px;
  padding-top: 5px;
  padding-left: 10px;
  display: flex;
}
`;

export const InputIcon = styled.img`
  height: auto;
`;

export const ExpandIcon = styled(InputIcon)<{ isOpen: boolean }>`
  width: 22px;
  cursor: pointer;
  margin-right: 10px;
  transition: transform 0.5s ease-in-out;
  transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  position: relative;
  top: -2px;
`;

export const Collapsible = styled.div<{ isOpen: boolean }>`
  max-height: ${({ isOpen }) => (isOpen ? '1000px' : '0')};
  overflow: hidden;
  transition: max-height 0.5s ease-in-out;
`;

export const EditIcon = styled.img`
  width: 15px;
  margin-left: 2rem;
`;

export const Container = styled(Form)`
  display: flex;
  flex-direction: row;
  background: white;
  height: auto;
  width: auto;
  flex-wrap: nowrap;
  border-radius: 5px;
  min-height: 250px;
  padding-top: 1em;
  padding-bottom: 1em;
  @media only screen and (max-width: 1200px) {
    display: flex;
    flex-direction: column;
  }
`;

export const MailingAddress = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 50%;
  margin-right: 0.5em;
  @media only screen and (max-width: 1200px) {
    width: 100%;
  }
`;

export const EmploymentInfo = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 40%;
  @media only screen and (max-width: 1200px) {
    width: 100%;
    margin-bottom: 20px;
  }
`;

export const FormTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-left: 1.5em;
  align-items: center;
`;

export const FormTitleItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const FormRow = styled.div`
  display: flex;
`;

export const MailingAddressFormContainer = styled.div`
  display: flex;
  margin-left: 1.5em;
  flex-wrap: wrap;
`;

export const FormInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0px;
  margin: 0.5em;
`;

export const SeparatorLine = styled.div`
  border-left: 2px solid #b6b4bd;
  height: 200px;
  align-self: center;
  @media only screen and (max-width: 1200px) {
    display: flex;
    width: 100%;
    border-left: 0;
    height: 10px;
    align-self: center;
    margin: 0.5em;
    border-top: 10px solid #f3f4f8;
  }
`;

export const SeparatorLineStraight = styled.div`
  min-height: 1.5px;
  background-color: #9399b247;
  margin-bottom: 20px;
`;
